import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isAuth: !!localStorage.getItem('tokenMANAGER'),
  selectedAddresses: new Set(),
}

export const managerSlice = createSlice({
  name: 'manager',
  initialState,
  reducers: {
    setAuth: (state) => {
        state.isAuth = true
    },
    addAddress: (state, action) => {
        state.selectedAddresses.add(action.payload);
    },
    deleteAddress: (state, action) => {
        state.selectedAddresses.delete(action.payload);
    },
    clearAddresses: (state) => {
      state.selectedAddresses.clear();
  },
  },
  
})

export const { addAddress, deleteAddress, clearAddresses, setAuth } = managerSlice.actions

export default managerSlice.reducer